import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-contract",
  templateUrl: "./med-icon-contract.component.html",
})
export class MedIconContractComponent extends SvgMixinLargeComponent { }
